import React, { Component } from "react";
import {Button, Modal} from "react-bootstrap";
import {MAX_WIDTH_SP, TEXT_CLOSE} from "../../const";

export default class ModalConfirmSelectNewStone extends Component {
  handleClose() {
    let {
      handleUpdateState,
    } = this.props;

    handleUpdateState('isShowModalConfirmSelectNewStone', false);
    handleUpdateState('isShowModalSelectSize', false);
    handleUpdateState('isShowModalFortuneList', false);
    handleUpdateState('isShowModalColorList', false);
    handleUpdateState('isShowModalMaterial', false);
    handleUpdateState('isShowModalRingList', false);
    handleUpdateState('isShowPopupSp', false);

  }
  render() {
    let {
      isShowModalConfirmSelectNewStone,
      handleUpdateState,
      getWidthBrowser
    } = this.props;

    return (
      <Modal
        show={isShowModalConfirmSelectNewStone}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-confirm-select-new-stone modal-dialog-centered dialog_custom"
        onHide={() => handleUpdateState("isShowModalConfirmSelectNewStone", false)}
        centered
      >
        <Modal.Body>
          <span>素材がボックス追加されました！</span>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.handleClose()}>
            ボックスを見る
          </Button>
          <Button variant="red" onClick={() => handleUpdateState("isShowModalConfirmSelectNewStone", false)}>
            選択を続ける
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
